import Dragger from "antd/es/upload/Dragger";
import {
  Field,
  Legend,
  Label,
  Fieldset,
  Description,
  ErrorMessage,
} from "../tailwind/fieldset";
import { Input, InputGroup } from "../tailwind/input";
import { Textarea } from "../tailwind/textarea";
import { Text } from "../tailwind/text";
import { Divider } from "../tailwind/divider";
import { Select } from "../tailwind/select";
import { handleUpdateCardComponent } from "../handleUpdateCardComponent";
import { handleUpdateAllCardsButton } from "../handleUpdateAllCardsButton";
import { handleUpdateCardButton } from "../handleUpdateCardButton";
import { InboxOutlined } from "@ant-design/icons";
import { Tooltip } from "../Tooltip";
import { Radio, RadioField, RadioGroup } from "../tailwind/radio";
import SelectInput from "../tailwind/select-input";
import { handleUpdateAllCardsComponent } from "../handleUpdateAllCardsComponent";
import { useCallback, useState } from "react";
import { handleMessageChange } from "../handleMessageChange";
import { Button } from "../tailwind/button";
import { TrashIcon } from "@heroicons/react/16/solid";
import { handleUploadFile } from "../../functions/handleUploadFile";
import { handleBeforeUploadFile } from "../../functions/handleBeforeUploadFile";
import formChecks from "../../functions/templateFormVerification"

//Modify form
export const CarouselForm = ({
  api,
  user,
  isInPanel,
  selectedNode,
  nodes,
  setNodes,
  edges,
  setEdges,
  selectedCardsHeader,
  setSelectedCardsHeader,
  cards,
  setCards,
  isUploading,
  setIsUploading,
  paramOptions,
  addVariable,
  buttonCardRefs,
  bodyCardRefs,
  parameterToInsert,
  setParameterToInsert,
  updateBodyCardParameters,
  deleteEdge,
  setModifications,
  carouselCardIndex,
  setCarouselCardIndex,
  carouselComponentIndex,
  setCarouselComponentIndex,
  setFile,
  setIsPanelOpened,
  setIsConvertCompressDialogOpen,
  selectedNodeConvertCompress,
  setSelectedNodeConvertCompress,
  bodyCardErrors,
  setBodyCardErrors,
  buttonCardErrors,
  setButtonCardErrors,
}) => {

  const updateStateArray = (array, setArray, index, value) => {
    setArray(prev => {
      const next = [...prev];
      next[index] = value;
      return next;
    });
  }

  const updateButtonErrorField = (cardIdx, buttonIdx, field, value) => {
    setButtonCardErrors(prev => {
      const next = [...prev];
      if (!next[cardIdx]) next[cardIdx] = {};
      next[cardIdx] = {
        ...next[cardIdx],
        [buttonIdx]: {
          ...(next[cardIdx][buttonIdx] || {}),
          [field]: value,
        },
      };
      return next;
    });
  }
  const handleHeaderCardsChange = useCallback(
    (value) => {
      setSelectedCardsHeader([value]);

      if (isInPanel) {
        setModifications(true);
        if (value === "image") {
          const headerParameters = {
            link: "",
            type: "HEADER",
            format: "IMAGE",
          };

          handleUpdateAllCardsComponent(
            selectedNode,
            "HEADER",
            headerParameters,
            nodes,
            setNodes,
            setCards,
          );
        }
        if (value === "video") {
          const headerParameters = {
            link: "",
            type: "HEADER",
            format: "VIDEO",
          };
          handleUpdateAllCardsComponent(
            selectedNode,
            "HEADER",
            headerParameters,
            nodes,
            setNodes,
            setCards,
          );
        }
      }
    },
    [selectedCardsHeader, selectedNode],
  );

  const deleteConnectedEdges = async (index) => {
    const handleIndexMapping = [..."abcdefghijklmnopqrstuvwxyz"];
    const edgesToDelete = [];

    for (const edge of edges) {
      if (edge.source === selectedNode.id && edge.sourceHandle !== "main") {
        for (let i = 0; i < cards.length; i++) {
          const btnIdx = i * 2 + index;
          const handleButton = handleIndexMapping[btnIdx];
          if (edge.sourceHandle === handleButton) {
            edgesToDelete.push(edge);
            break;
          }
        }
      }
    }

    for (const edge of edgesToDelete) {
      await deleteEdge(edge, setEdges, api);
    }

    const updatedEdges = edges.filter((edge) => !edgesToDelete.includes(edge));
    setEdges(updatedEdges);
  };

  const deleteEdgesConnectedToCard = (lastExistingIndex) => {
    const handleIndexMapping = [..."abcdefghijklmnopqrstuvwxyz"];

    const updatedEdges = edges.filter((edge) => {
      if (edge.source === selectedNode.id && edge.sourceHandle !== "main") {
        const btn1Idx = lastExistingIndex * 2 + 0;
        const btn2Idx = lastExistingIndex * 2 + 1;
        const handle1Button = handleIndexMapping[btn1Idx];
        const handle2Button = handleIndexMapping[btn2Idx];

        if ([handle2Button, handle1Button].includes(edge.sourceHandle)) {
          deleteEdge(edge, setEdges, api);
          return false;
        }
      }
      return true;
    });

    setEdges(updatedEdges);
  };

  const [selectedFirstButtonType, setSelectedFirstButtonType] = useState(
    selectedNode?.data?.cards?.[0]?.components?.find(
      (c) => c.type === "BUTTONS",
    )?.buttons[0]?.type === "URL" ||
      selectedNode?.data?.cards?.[0]?.components?.find(
        (c) => c.type === "BUTTONS",
      )?.buttons[0]?.type === "url"
      ? "URL"
      : "QUICK_REPLY",
  );
  const [selectedSecondButtonType, setSelectedSecondButtonType] = useState(
    selectedNode?.data?.cards?.[0]?.components?.find(
      (c) => c.type === "BUTTONS",
    )?.buttons[1]?.type === "URL" ||
      selectedNode?.data?.cards?.[0]?.components?.find(
        (c) => c.type === "BUTTONS",
      )?.buttons[1]?.type === "url"
      ? "URL"
      : "QUICK_REPLY",
  );
  const [hasTwoButtonsByCard, setHasTwoButtonsByCards] = useState(
    selectedNode?.data?.cards?.[0]?.components?.find(
      (c) => c.type === "BUTTONS",
    )?.buttons.length > 1,
  );
  const buttonTypeOptions = [
    { label: "Quick reply", value: "QUICK_REPLY" },
    { label: "Url button", value: "URL" },
  ];
  return (
    <>
      <Field>
        <Legend>Carousel</Legend>
        <div className="border px-4 pt-2 rounded-customBorderRadius">
          <div className="flex items-end">
            <Text className="text-sm mb-1 font-bold text-black mr-2 flex justify-between items-end w-full">
              Cards structure
            </Text>
            <Tooltip
              size="4"
              content={
                <div>
                  All cards must have the same header format and the same
                  buttons type.
                  <br />
                  The header and the first button are required.
                </div>
              }
            />
          </div>
          <Fieldset>
            <Text className="text-sm mb-1">Header type</Text>
            <RadioGroup
              name="header_cards"
              value={selectedCardsHeader[0]}
              onChange={(value) => {
                handleHeaderCardsChange(value);
                if (isInPanel) {
                  setModifications(true);
                }
              }}
            >
              <RadioField>
                <Radio value="image" />
                <Label>Image</Label>
                <Description>
                  You can import your images once the template is submitted
                </Description>
              </RadioField>
              <RadioField>
                <Radio value="video" />
                <Label>Video</Label>
                <Description>
                  You can import your videos once the template is submitted
                </Description>
              </RadioField>
            </RadioGroup>
          </Fieldset>
          <Fieldset>
            <Text className="text-sm mb-1">Buttons type</Text>
            <Field className="mb-[20px]">
              <SelectInput
                placeholder="Quick reply"
                value={selectedFirstButtonType}
                onChange={(value) => {
                  setSelectedFirstButtonType(value);
                  if (isInPanel) {
                    setModifications(true);
                  }
                  if (value === "URL" || value === "url") {
                    deleteConnectedEdges(0);
                  }
                  handleUpdateAllCardsButton(
                    selectedNode,
                    "BUTTONS",
                    { type: value },
                    0,
                    nodes,
                    setNodes,
                    setCards,
                  );
                }}
                options={buttonTypeOptions}
                selected={selectedFirstButtonType}
              />
              {hasTwoButtonsByCard && (
                <div className="mt-1">
                  <SelectInput
                    placeholder="Quick reply"
                    value={selectedSecondButtonType}
                    onChange={(value) => {
                      setSelectedSecondButtonType(value);
                      if (isInPanel) {
                        setModifications(true);
                      }
                      if (value === "URL" || value === "url") {
                        deleteConnectedEdges(1);
                      }
                      handleUpdateAllCardsButton(
                        selectedNode,
                        "BUTTONS",
                        { type: value },
                        1,
                        nodes,
                        setNodes,
                        setCards,
                      );
                    }}
                    options={buttonTypeOptions}
                    selected={selectedSecondButtonType}
                  />
                  <div className="w-full flex justify-end mt-1">
                    <Button
                      color="optionButton"
                      className=""
                      onClick={() => {
                        const updatedCards = selectedNode.data.cards.map(
                          (card) => ({
                            ...card,
                            components: card.components.map((component) => {
                              if (
                                component.type === "BUTTONS" &&
                                Array.isArray(component.buttons)
                              ) {
                                return {
                                  ...component,
                                  buttons: component.buttons.filter(
                                    (_, idx) => idx !== 1,
                                  ),
                                };
                              }
                              return component;
                            }),
                          }),
                        );
                        handleMessageChange(
                          "cards",
                          updatedCards,
                          nodes,
                          setNodes,
                        );
                        setCards(updatedCards);
                        setHasTwoButtonsByCards(false);
                        deleteConnectedEdges(1);
                        setSelectedSecondButtonType("QUICK_REPLY");
                        if (isInPanel) {
                          setModifications(true);
                        }
                      }}
                    >
                      Remove second button
                    </Button>
                  </div>
                </div>
              )}
              {!hasTwoButtonsByCard && (
                <div className="w-full flex justify-end mt-1">
                  <Button
                    color="optionButton"
                    onClick={() => {
                      const updatedCards = selectedNode.data.cards.map(
                        (card) => {
                          return {
                            ...card,
                            components: card.components.map((component) => {
                              if (
                                component.type === "BUTTONS" &&
                                Array.isArray(component.buttons)
                              ) {
                                // Si le nombre de boutons est inférieur à 2, on insère le nouveau bouton à l'index 1
                                if (component.buttons.length < 2) {
                                  const newButtons = [...component.buttons];
                                  newButtons.splice(1, 0, {
                                    type: "QUICK_REPLY",
                                    text: "",
                                  });
                                  return {
                                    ...component,
                                    buttons: newButtons,
                                  };
                                }
                              }
                              return component;
                            }),
                          };
                        },
                      );
                      handleMessageChange(
                        "cards",
                        updatedCards,
                        nodes,
                        setNodes,
                      );
                      setCards(updatedCards);
                      setHasTwoButtonsByCards(true);
                      if (isInPanel) {
                        setModifications(true);
                      }
                    }}
                  >
                    Add second button
                  </Button>
                </div>
              )}
            </Field>
          </Fieldset>
        </div>

        {cards.map((card, cardIndex) => (
          <div key={`card-${cardIndex}`}>
            <div className="relative">
              <Text className="text-base font-bold mt-2">{`Card n° ${
                cardIndex + 1
              }`}</Text>
              {cards.length > 2 && (
                <div className="absolute right-0 top-0">
                  <Button
                    color="optionButton"
                    onClick={() => {
                      const lastExistingIndex = cards.length - 1;
                      const updatedCards = cards.filter(
                        (_, index) => index !== cardIndex,
                      );
                      handleMessageChange(
                        "cards",
                        updatedCards,
                        nodes,
                        setNodes,
                      );
                      setCards(updatedCards);
                      deleteEdgesConnectedToCard(lastExistingIndex);
                      if (isInPanel) {
                        setModifications(true);
                      }
                    }}
                  >
                    <TrashIcon />
                  </Button>
                </div>
              )}
            </div>

            {card.components?.map((component, componentIndex) => {
              switch (component.type) {
                case "HEADER":
                  return (
                    <div key={`header-${cardIndex}-${componentIndex}`}>
                      <Field>
                        <Text className="text-sm mb-1">
                          {`Header ${
                            selectedCardsHeader[0]?.toLowerCase() === "image"
                              ? "image"
                              : "video"
                          }`}
                        </Text>

                        <Field>
                          <Input
                            className="mb-1"
                            name="header URL"
                            key={`header_URL_card_${componentIndex}`}
                            value={component.link}
                            onChange={(e) => {
                              const newValue = e.target.value;
                              handleUpdateCardComponent(
                                selectedNode,
                                cardIndex,
                                componentIndex,
                                { link: newValue },
                                nodes,
                                setNodes,
                                setCards,
                              );
                              if (isInPanel) {
                                setModifications(true);
                              }
                            }}
                            placeholder="https://example.com/"
                            autoComplete="off"
                            maxLength={2000}
                          />

                          <Dragger
                            className="mb-1"
                            name="file"
                            key="file"
                            showUploadList={false}
                            maxCount={1}
                            accept={
                              selectedCardsHeader[0]?.toLowerCase() === "image"
                                ? "image/jpeg,image/png,application/pdf"
                                : "video/mp4"
                            }
                            disabled={isUploading}
                            multiple={false}
                            height={200}
                            beforeUpload={(file) => {
                              const isValid = handleBeforeUploadFile({
                                file: file,
                                setFile: setFile,
                                selectedHeader: selectedCardsHeader[0],
                                setIsPanelOpened: setIsPanelOpened,
                                setIsConvertCompressDialogOpen:
                                  setIsConvertCompressDialogOpen,
                                selectedNode: selectedNode,
                                cardIndex: cardIndex,
                                componentIndex: componentIndex,
                                carouselCardIndex: carouselCardIndex,
                                setCarouselCardIndex: setCarouselCardIndex,
                                carouselComponentIndex: carouselComponentIndex,
                                setCarouselComponentIndex:
                                  setCarouselComponentIndex,
                                selectedNodeConvertCompress:
                                  selectedNodeConvertCompress,
                                setSelectedNodeConvertCompress:
                                  setSelectedNodeConvertCompress,
                              });
                              return isValid;
                            }}
                            action={(file) =>
                              handleUploadFile({
                                file: file,
                                setIsUploading: setIsUploading,
                                user: user,
                                selectedNode: selectedNode,
                                nodes: nodes,
                                setNodes: setNodes,
                                setCards: setCards,
                                setModifications: setModifications,
                                carouselCardIndex: cardIndex,
                                carouselComponentIndex: componentIndex,
                                selectedHeader: selectedCardsHeader[0],
                                isInPanel: false,
                              })
                            }
                            onDrop={(e) => {
                              console.log(
                                "Dropped files",
                                e.dataTransfer.files,
                              );
                            }}
                          >
                            <p className="ant-upload-drag-icon">
                              <InboxOutlined />
                            </p>
                            <p className="ant-upload-text">
                              Click or drag-and-drop a file to import it
                            </p>
                            <p className="ant-upload-hint">
                              {selectedCardsHeader[0]?.toLowerCase() === "image"
                                ? "Please upload a .jpeg or .png file. It must be less than 5MB."
                                : "Please upload a .mp4 file smaller than 16MB"}
                            </p>
                          </Dragger>
                        </Field>
                      </Field>
                    </div>
                  );

                case "BODY": {
                  const adjustHeight = (cardIndex) => {
                    const target = bodyCardRefs.current[cardIndex];
                    if (target && target.style) {
                      target.style.height = "auto";
                      target.style.height = `${target.scrollHeight + 15}px`;
                    }
                  };
                  return (
                    <div key={`body-${cardIndex}-${componentIndex}`}>
                      <Text className="text-base mb-1 mt-2">Body</Text>
                      <Textarea
                        name={`message_body_cards_${cardIndex}`}
                        key={`message_body_cards_${cardIndex}`}
                        ref={(el) => (bodyCardRefs.current[cardIndex] = el)}
                        placeholder="Message body"
                        value={component.text}
                        onChange={(e) => {
                          const updatedValue = e.target.value;
                          console.log(updatedValue);
                          if (isInPanel) {
                            setModifications(true);
                            updateBodyCardParameters(
                              updatedValue,
                              cardIndex,
                              componentIndex,
                            );
                            handleUpdateCardComponent(
                              selectedNode,
                              cardIndex,
                              componentIndex,
                              { text: updatedValue },
                              nodes,
                              setNodes,
                              setCards,
                            );
                            adjustHeight(cardIndex);
                          }
                        }}
                        maxLength={160}
                        showCharacterCount
                        autoComplete="off"
                        invalid={!!bodyCardErrors[cardIndex]}
                        onBlur={(e)=> {updateStateArray(bodyCardErrors, setBodyCardErrors,cardIndex,formChecks.checkBody(e.target.value))}}
                      />
                      {bodyCardErrors[cardIndex] && (
                        <ErrorMessage>{bodyCardErrors[cardIndex]}</ErrorMessage>
                      )}
                      <div className="flex mt-2 w-full justify-between">
                        <div className="flex-grow mr-1">
                          <SelectInput
                            placeholder="Select a parameter"
                            value={parameterToInsert}
                            onChange={(value) => {
                              setParameterToInsert(value);
                            }}
                            options={paramOptions}
                            selected={parameterToInsert}
                          />
                        </div>

                        <Button
                          color="secondaryButton"
                          disabled={parameterToInsert === ""}
                          onClick={() => {
                            addVariable(true, cardIndex, componentIndex);
                          }}
                        >
                          Add parameter
                        </Button>
                      </div>
                      {component.bodyParameters &&
                        component.bodyParameters.length > 0 &&
                        component.bodyParameters?.map((p, index) => (
                          <Field key={index + "field-body_params_cards"}>
                            <Divider
                              className="mt-5 mb-3"
                              key={index + "divider_cards"}
                            />
                            <Label key={index + "label_cards"}>{`Parameter ${
                              index + 1
                            }`}</Label>
                            <Select
                              className="mb-2"
                              key={index + "bodyParam_cards"}
                              placeholder="Select a parameter"
                              onChange={(e) => {
                                var newParams = component.bodyParameters
                                  ? component.bodyParameters.map((param) => ({
                                      ...param,
                                    }))
                                  : [];

                                // Modifier le paramètre sélectionné
                                newParams[index] = {
                                  type: "text",
                                  selected: e.target.value,
                                  default:
                                    component.bodyParameters?.[index].default ||
                                    "",
                                };

                                handleUpdateCardComponent(
                                  selectedNode,
                                  cardIndex,
                                  componentIndex,
                                  { bodyParameters: newParams },
                                  nodes,
                                  setNodes,
                                  setCards,
                                );
                                if (isInPanel) {
                                  setModifications(true);
                                }
                              }}
                              value={component.bodyParameters?.[index].selected}
                            >
                              {paramOptions.map((option, index) => (
                                <option
                                  key={`${option.value}-${index}`}
                                  value={option.value}
                                >
                                  {option.label}
                                </option>
                              ))}
                            </Select>

                            <div className="flex justify-between items-center">
                              <Label key={index + "defaultLabel"}>
                                {"Default value"}
                              </Label>
                              <Input
                                className="max-w-[75%]"
                                type="text"
                                key={index + "defaultInput"}
                                placeholder="Value if parameter is empty"
                                autoComplete="off"
                                value={
                                  component.bodyParameters?.[index].default ||
                                  ""
                                }
                                onChange={(e) => {
                                  var newParams = component.bodyParameters
                                    ? component.bodyParameters.map((param) => ({
                                        ...param,
                                      }))
                                    : [];

                                  // Modifier le paramètre sélectionné
                                  newParams[index] = {
                                    type: "text",
                                    default: e.target.value,
                                    selected:
                                      component.bodyParameters?.[index]
                                        .selected || "",
                                  };

                                  handleUpdateCardComponent(
                                    selectedNode,
                                    cardIndex,
                                    componentIndex,
                                    {
                                      bodyParameters: newParams,
                                    },
                                    nodes,
                                    setNodes,
                                    setCards,
                                  );
                                  if (isInPanel) {
                                    setModifications(true);
                                  }
                                }}
                              />
                            </div>
                          </Field>
                        ))}
                    </div>
                  );
                }

                case "BUTTONS": {
                  const buttons = component.buttons ?? [];
                  const hasTwoButtons = buttons.length === 2;
                  const sameType =
                    hasTwoButtons &&
                    buttons[0].type.toLowerCase() ===
                      buttons[1].type.toLowerCase();

                  return (
                    <div
                      key={`buttons-${cardIndex}-${componentIndex}`}
                      className="mt-3"
                    >
                      <Divider className="mt-5" />
                      <div className="">
                        {buttons?.map((button, buttonIndex) => {
                          const shouldShowText =
                            !hasTwoButtons ||
                            (hasTwoButtons && sameType && buttonIndex === 0) ||
                            (hasTwoButtons && !sameType);
                          return (
                            <div
                              key={`btn-${cardIndex}-${buttonIndex}`}
                              className=""
                            >
                              {!shouldShowText && <br />}
                              <Field>
                                {button.type === "URL" ||
                                button.type === "url" ? (
                                  <>
                                    {shouldShowText && (
                                      <Text className="text-base mb-1 mt-2">{`Link${
                                        sameType ? "s" : ""
                                      }`}</Text>
                                    )}
                                    <InputGroup className="">
                                      <Input
                                        placeholder="Link title"
                                        name={`Button card ${buttonIndex + 1}`}
                                        key={`input-card-${buttonIndex}`}
                                        ref={(el) => {
                                          if (
                                            !buttonCardRefs.current[cardIndex]
                                          ) {
                                            buttonCardRefs.current[cardIndex] =
                                              {};
                                          }
                                          buttonCardRefs.current[cardIndex][
                                            buttonIndex
                                          ] = el;
                                        }}
                                        maxLength={25}
                                        value={button.text}
                                        showCharacterCount
                                        onChange={(e) => {
                                          handleUpdateCardButton(
                                            selectedNode,
                                            cardIndex,
                                            componentIndex,
                                            { text: e.target.value },
                                            nodes,
                                            setNodes,
                                            setCards,
                                            buttonIndex,
                                          );
                                          if (isInPanel) {
                                            setModifications(true);
                                          }
                                        }}
                                        onBlur={(e) => updateButtonErrorField(cardIndex, buttonIndex, "title", formChecks.checkCardUrlButtonTitle(e.target.value))}
                                        invalid={
                                          !!(
                                            buttonCardErrors[cardIndex] &&
                                            buttonCardErrors[cardIndex][
                                              buttonIndex
                                            ] &&
                                            buttonCardErrors[cardIndex][
                                              buttonIndex
                                            ].title
                                          )
                                        }
                                      />
                                      {buttonCardErrors[cardIndex] &&
                                        buttonCardErrors[cardIndex][
                                          buttonIndex
                                        ] &&
                                        buttonCardErrors[cardIndex][buttonIndex]
                                          .title && (
                                          <ErrorMessage>
                                            {
                                              buttonCardErrors[cardIndex][
                                                buttonIndex
                                              ].title
                                            }
                                          </ErrorMessage>
                                        )}
                                      <Input
                                        className="mt-1"
                                        placeholder="Link URL"
                                        name={`Button url ${buttonIndex + 1}`}
                                        key={`input-url-card-${buttonIndex}`}
                                        value={button.url ?? ""}
                                        ref={(el) => {
                                          if (
                                            !buttonCardRefs.current[cardIndex]
                                          ) {
                                            buttonCardRefs.current[cardIndex] =
                                              {};
                                          }
                                          buttonCardRefs.current[cardIndex][
                                            buttonIndex
                                          ] = el;
                                        }}
                                        onChange={(e) => {
                                          handleUpdateCardButton(
                                            selectedNode,
                                            cardIndex,
                                            componentIndex,
                                            { url: e.target.value },
                                            nodes,
                                            setNodes,
                                            setCards,
                                            buttonIndex,
                                          );
                                          if (isInPanel) {
                                            setModifications(true);
                                          }
                                        }}
                                        onBlur={(e) => updateButtonErrorField(cardIndex, buttonIndex, "url", formChecks.checkCardUrlButtonUrl(e.target.value))}
                                        invalid={
                                          !!(
                                            buttonCardErrors[cardIndex] &&
                                            buttonCardErrors[cardIndex][
                                              buttonIndex
                                            ] &&
                                            buttonCardErrors[cardIndex][
                                              buttonIndex
                                            ].url
                                          )
                                        }
                                      />
                                      {buttonCardErrors[cardIndex] &&
                                        buttonCardErrors[cardIndex][
                                          buttonIndex
                                        ] &&
                                        buttonCardErrors[cardIndex][buttonIndex]
                                          .url && (
                                          <ErrorMessage>
                                            {
                                              buttonCardErrors[cardIndex][
                                                buttonIndex
                                              ].url
                                            }
                                          </ErrorMessage>
                                        )}
                                      <div className="flex justify-end mt-1">
                                        <Button
                                          color="optionButton"
                                          disabled={
                                            button.url?.includes("{{1}}")
                                          }
                                          onClick={() => {
                                            const currentUrl = button.url ?? "";
                                            const newUrl = currentUrl + "{{1}}";
                                            handleUpdateCardButton(
                                              selectedNode,
                                              cardIndex,
                                              componentIndex,
                                              { url: newUrl },
                                              nodes,
                                              setNodes,
                                              setCards,
                                              buttonIndex,
                                            );
                                            if (isInPanel) {
                                              setModifications(true);
                                            }
                                          }}
                                        >
                                          Add url variable
                                        </Button>
                                      </div>
                                    </InputGroup>
                                  </>
                                ) : (
                                  <>
                                    {shouldShowText && (
                                      <Text className="text-base mb-1 mt-2">{`Button${
                                        sameType ? "s" : ""
                                      }`}</Text>
                                    )}
                                    <InputGroup className="">
                                      <Input
                                        placeholder="Button title"
                                        name={`Button card ${buttonIndex + 1}`}
                                        key={`input-card-${buttonIndex}`}
                                        ref={(el) => {
                                          if (
                                            !buttonCardRefs.current[cardIndex]
                                          ) {
                                            buttonCardRefs.current[cardIndex] =
                                              {};
                                          }
                                          buttonCardRefs.current[cardIndex][
                                            buttonIndex
                                          ] = el;
                                        }}
                                        value={button.text}
                                        maxLength={25}
                                        showCharacterCount
                                        onChange={(e) => {
                                          handleUpdateCardButton(
                                            selectedNode,
                                            cardIndex,
                                            componentIndex,
                                            { text: e.target.value },
                                            nodes,
                                            setNodes,
                                            setCards,
                                            buttonIndex,
                                          );
                                          if (isInPanel) {
                                            setModifications(true);
                                          }
                                        }}
                                        onBlur={(e) => updateButtonErrorField(cardIndex, buttonIndex, "text", formChecks.checkCardQuickReplyText(e.target.value))}
                                        invalid={
                                          !!(
                                            buttonCardErrors[cardIndex] &&
                                            buttonCardErrors[cardIndex][
                                              buttonIndex
                                            ] &&
                                            buttonCardErrors[cardIndex][
                                              buttonIndex
                                            ].text
                                          )
                                        }
                                      />
                                      {buttonCardErrors[cardIndex] &&
                                        buttonCardErrors[cardIndex][
                                          buttonIndex
                                        ] &&
                                        buttonCardErrors[cardIndex][buttonIndex]
                                          .text && (
                                          <ErrorMessage>
                                            {
                                              buttonCardErrors[cardIndex][
                                                buttonIndex
                                              ].text
                                            }
                                          </ErrorMessage>
                                        )}
                                    </InputGroup>
                                  </>
                                )}
                              </Field>
                            </div>
                          );
                        })}
                      </div>
                      {cardIndex !== cards.length - 1 && (
                        <>
                          <Divider className="mt-5" />
                          <Divider className="mt-1" />
                        </>
                      )}
                    </div>
                  );
                }

                default:
                  return null;
              }
            })}
          </div>
        ))}
        {cards.length < 10 && (
          <div className="w-full flex justify-end mt-3">
            <Button
              color="optionButton"
              onClick={() => {
                const emptyCard = {
                  components: [
                    {
                      link: "",
                      type: "HEADER",
                      format: "IMAGE",
                    },
                    {
                      text: "",
                      type: "BODY",
                      bodyParameters: [],
                    },
                    {
                      type: "BUTTONS",
                      buttons: [
                        {
                          text: "",
                          type: selectedFirstButtonType,
                          ...((selectedFirstButtonType === "URL" ||
                            selectedFirstButtonType === "url") && {
                            url: "",
                          }),
                        },
                        ...(hasTwoButtonsByCard
                          ? [
                              {
                                text: "",
                                type: selectedSecondButtonType,
                                ...((selectedSecondButtonType === "URL" ||
                                  selectedFirstButtonType === "url") && {
                                  url: "",
                                }),
                              },
                            ]
                          : []),
                      ],
                    },
                  ],
                };
                const updatedCards = [...cards, emptyCard];
                handleMessageChange("cards", updatedCards, nodes, setNodes);
                setCards(updatedCards);
                if (isInPanel) {
                  setModifications(true);
                }
              }}
            >
              Add a card
            </Button>
          </div>
        )}
      </Field>
    </>
  );
};
